import { fromLongToShort } from '@/components/shared/languageCodes';
import i18n from '@/lang/lang';
import defaultState from './state';


const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

const SET_BACK_ROUTE = (state, routeName) => {
  state.backRoute = routeName;
};
const SET_LAST_CLASSES_PATH = (state, routeName) => {
  state.lastClassesPath = routeName;
};
const SET_USER_SETTINGS = (state, settings) => {
  state.userSettings = settings;
};

const SET_APPLE_LOGIN_DETAILS = (state, details) => {
  state.appleDetails = details;
};

const SET_LEARNED_LANGUAGE = (state, lang) => {
  // if (lang == null) {
  //   state.taughtLanguage = 'en';
  // } else {
  state.learnedLanguage = lang;
  // }
};

const SET_SITE_LANGUAGE = (state, lang) => {
  state.siteLanguage = lang;
  i18n.locale = lang;
  const html = document.documentElement;
  if (html) { html.setAttribute('lang', fromLongToShort[lang]); }
};

const SET_WINDOW_WIDTH = (state, size) => {
  state.windowWidth = size;
};

const SET_USER_IS_LOGGED_IN = (state, userIsLoggedIn) => {
  state.userIsLoggedIn = userIsLoggedIn;
};

const SET_SESSION_EXPIRED = (state, sessionExpired) => {
  state.sessionExpired = sessionExpired;
};

// const SET_FORCE_WEB_VIEW_STATUS = (state, forceWebViewStatus) => {
//   state.forceWebViewStatus = forceWebViewStatus;
// };

// const SET_DKT_DEEPLINK_PARAMS = (state, object) => {
//   state.dktDeeplinkParams = {
//     ...state.sessionExpired,
//     ...object
//   };
// };

const SET_DKT_DEEPLINK_PARAMS = (state, object) => {
  const defaultStateOptions = {
    assignmentId: undefined,
    dktAssignmentId: undefined,
    idpToken: undefined
  };
  let newValue = object;
  const oldOptions = window.sessionStorage.getItem('dktDeeplinkParams');
  if (oldOptions) {
    newValue = {
      ...defaultStateOptions,
      ...JSON.parse(oldOptions),
      ...object
    };
  } else {
    newValue = { ...defaultStateOptions, ...object };
  }
  window.sessionStorage.setItem('dktDeeplinkParams', JSON.stringify(newValue));
};

const SET_HANDLED_UNAUTHORIZED_ERROR = (state, handledUnauthorizedError) => {
  state.handledUnauthorizedError = handledUnauthorizedError;
};

const SET_GUEST_LINK = (state, guestLink) => {
  state.guestLink = guestLink;
};

const SET_GUEST_ERROR = (state, guestError) => {
  state.guestError = guestError;
};

const SET_APP_BANNER_VISIBLE = (state, appBannerVisible) => {
  state.appBannerVisible = appBannerVisible;
};

const SET_NARRATOR_LANGUAGE = (state, lang) => {
  state.narratorLanguage = lang;
};

const SET_WCAG_SETTING = (state, object) => {
  const currentWCAGSettings = state.wcag;
  state.wcag = { ...currentWCAGSettings, ...object };
};

export default {
  SET_BACK_ROUTE,
  SET_LAST_CLASSES_PATH,
  SET_USER_SETTINGS,
  SET_APPLE_LOGIN_DETAILS,
  SET_LEARNED_LANGUAGE,
  SET_SITE_LANGUAGE,
  SET_WINDOW_WIDTH,
  SET_USER_IS_LOGGED_IN,
  SET_SESSION_EXPIRED,
  // SET_FORCE_WEB_VIEW_STATUS,
  SET_DKT_DEEPLINK_PARAMS,
  DESTROY,
  SET_HANDLED_UNAUTHORIZED_ERROR,
  SET_GUEST_LINK,
  SET_GUEST_ERROR,
  SET_APP_BANNER_VISIBLE,
  SET_NARRATOR_LANGUAGE,
  SET_WCAG_SETTING
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/mutations.js